import { TFeaturePlanResponse } from '~/types/server.types';
import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import { IAccountSettings } from '~/types/model.types';

export class AccountAdapter extends BaseHttpAdapter {
    fetchFeaturePlan(accountId: string) {
        return this.apiService.apiRequest<TFeaturePlanResponse>({
            method: 'get',
            url: `/api/v2/account/${accountId}/feature_plan`
        });
    }

    updateAccountSettings(
        accountId: string,
        settings: Partial<IAccountSettings>
    ) {
        return this.apiService.apiRequest<{
            account_settings: IAccountSettings;
        }>({
            method: 'put',
            url: `/api/v2/account/${accountId}/settings`,
            data: { account_settings: settings }
        });
    }

    joinWaitlist(accountId: string, featureName: string) {
        return this.apiService.apiRequest<void>({
            method: 'post',
            url: `/api/v2/account/${accountId}/waitlist`,
            data: { feature_name: featureName }
        });
    }

    revertToOldAutomations(accountId: string) {
        return this.apiService.apiRequest<void>({
            method: 'put',
            url: `/api/v2/account/${accountId}/revert_to_old_automation`
        });
    }
}
